import React from 'react'
import { AppBar, Toolbar, Box } from '@mui/material'
import { Link } from 'react-router-dom'

export const TempNavbar = () => {
  return (
    <>
      <AppBar color='inherit'>
        <Toolbar>
          <Box display='flex' justifyContent='space-between' width='100%'>
            <Link to='/'>
              <Box display='flex' align='center' pr={1}>
                <img src='/images/HTGROUP_IMG.png' width={150} height={38} alt='htgroup-logo' />
              </Box>
            </Link>
          </Box>
        </Toolbar>
      </AppBar>
      <Toolbar />
    </>
  )
}
